import { render } from "./PanelEmpleado.vue?vue&type=template&id=4a0d2a9c&scoped=true"
import script from "./PanelEmpleado.vue?vue&type=script&lang=js"
export * from "./PanelEmpleado.vue?vue&type=script&lang=js"

import "./PanelEmpleado.vue?vue&type=style&index=0&id=4a0d2a9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0d2a9c"]])

export default __exports__